// Error raised by the api layer when a request *completes* but the server
// (or the mock) reports a failure — `status` carries the HTTP status so
// callers can distinguish, e.g., 401 (bad credentials) from 500. A request
// that never completes (fetch rejecting because the host is unreachable)
// surfaces as a plain TypeError with no `status`; the UI reads that as
// "couldn't reach the server" rather than "wrong credentials".
export class ApiError extends Error {
	constructor(
		message: string,
		readonly status: number,
		readonly code?: string,
		// Подробности ответа шлюза (например, дубли заявки при 409) — UI
		// показывает их, не переспрашивая сервер.
		readonly details?: unknown,
	) {
		super(message);
		this.name = "ApiError";
	}
}
